import * as ls from 'util/localStorage';

export const load = () => ls.getJson('removedIngredients') || [];
export const unload = data => ls.setJson('removedIngredients', data);
